import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './AddSuggestionsAndSystemEnhancement.html';
import { SuggestionsAndSystemEnhancementModel } from '../SuggestionsAndSystemEnhancementModel';
import { Toaster } from '../../../Services/toast';
import LoaderService from '../../../Services/LoaderService';
import SuggestionsAndSystemEnhancementService from '../SuggestionsAndSystemEnhancementService';
import UserService from '../../../shared/userService/UserService';
import UserModel from '../../../shared/userService/Model/UserModel';
import { ProviderModel } from '../../Provider/ProviderModel';
import ProviderService from '../../Provider/ProviderService';
import { SuggestionServiceType } from '../SuggestionServiceType';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        SuggestionsAndSystemEnhancementService,
        LoaderService,
        UserService,
        ProviderService,
    ],
})
export default class AddSuggestionsAndSystemEnhancement extends Vue {
    @Inject(SuggestionsAndSystemEnhancementService) public SuggestionsAndSystemEnhancementService!: SuggestionsAndSystemEnhancementService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    @Inject(UserService) public userService!: UserService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    public addSuggestionDialog: boolean = false;
    public user: UserModel = {} as UserModel;
    public provider: ProviderModel = {} as ProviderModel;

    public myService: number | null = null;
    public title: string = '';
    public suggestionText: string = '';

    public services: { name: string; id: number }[] = [
        { name: 'New Service', id: SuggestionServiceType.NewService },
        { name: 'Sender Name Registration', id: SuggestionServiceType.SenderNameRegistration },
        { name: 'Contract Request', id: SuggestionServiceType.ContractRequest },
        { name: 'Renewal Request', id: SuggestionServiceType.RenewalRequest },
        { name: 'Connectivity Request', id: SuggestionServiceType.ConnectivityRequest },
        { name: 'Payment', id: SuggestionServiceType.Payment },
    ];


    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.user = await this.userService.getUser();
        this.provider = await this.providerService.GetById(this.user.details.ProviderId);
    }

    public get isValid(): boolean {
        return (
            this.provider.name.trim() !== '' &&
            this.myService !== null &&
            this.title.trim() !== '' &&
            this.suggestionText.trim() !== ''
        );
    }

    public showaddSuggestionDialog() {
        this.addSuggestionDialog = true;
    }

    public hideddSuggestionDiDialog() {
        this.addSuggestionDialog = false;
    }

    public resetForm() {
        this.myService = null;
        this.title = '';
        this.suggestionText = '';
    }

      
    public async addSuggestion() {
        const payload: SuggestionsAndSystemEnhancementModel = {
            providerName: this.provider.name,
            service: this.myService!,
            title: this.title.trim(),
            description: this.suggestionText.trim(),
        };

        const response = await this.SuggestionsAndSystemEnhancementService.addSuggestion(payload);

        if (response.isSuccess) {
            Toaster.success(this.$t('shared.addSuggestionSuccess').toString());
            this.resetForm();
            this.hideddSuggestionDiDialog();
            this.$router.push({ name: 'Dashboard' });
        } else {
            Toaster.error(response.errorMessage);
        }
    }
}